import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { getWhatsAppUrl } from '../../utils/whatsapp';

const StickyMobileCTA = () => {
  return (
    <>
      <a
        href={getWhatsAppUrl()}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-gradient-to-r from-pink-500 via-fuchsia-500 to-orange-400 rounded-2xl flex items-center justify-center shadow-[0_4px_24px_rgba(236,72,153,0.4)] hover:shadow-[0_4px_32px_rgba(236,72,153,0.55)] hover:scale-[1.05] transition-all duration-200 group"
        data-testid="whatsapp-float-button"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="w-7 h-7 text-white" />
        <span className="absolute right-full mr-3 bg-zinc-800 text-white text-xs px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap border border-white/10">
          Chat with us
        </span>
      </a>

      <div className="fixed bottom-0 left-0 right-0 z-30 lg:hidden bg-[#0a0a0b]/80 backdrop-blur-xl border-t border-white/[0.06] px-4 py-3 hidden" data-testid="sticky-mobile-cta">
        <a
          href={getWhatsAppUrl()}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full bg-white text-zinc-900 py-3 rounded-xl font-medium text-sm hover:bg-zinc-100 transition-all active:scale-[0.97]"
        >
          <FaWhatsapp className="w-5 h-5" />
          Get Your Free Demo
        </a>
      </div>
    </>
  );
};

export default StickyMobileCTA;
